const SectionAccordion = ({ title, index, openIndex, setOpenIndex, children }) => {
    const isOpen = openIndex === index;

    const handleToggle = () => {
        setOpenIndex(isOpen ? -1 : index);
    };

    return (
        <div className="w-full border rounded mb-1 bg-white transition-all duration-200">
            <button
                type="button"
                className="w-full flex justify-between items-center px-2 py-2 text-base font-semibold border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-gray-600 hover:bg-gray-50"
                onClick={handleToggle}
                aria-expanded={isOpen}
            >
                <span className="flex-1 text-center">{title}</span>
                <span className="text-xl font-bold ml-1">
                    {isOpen ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    )}
                </span>
            </button>
            <div
                className={`${isOpen ? '' : 'hidden'} px-2 pb-2 pt-1`}
                aria-hidden={!isOpen}
            >
                {children}
            </div>
        </div>
    );
};

export default SectionAccordion;
